import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/fonts.css";
import "./index.css";
import App from "./App";
import { WPToastNotificationProvider } from "./packages/WPToastNotification";
import reportWebVitals from "./reportWebVitals";
import i18n from "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WPToastNotificationProvider>
    <App />
  </WPToastNotificationProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
